export const deliveryOptionsCodes = {
    home: "Domicilio",
    merchant: "Recoger en tienda",
    store: "Recoger en tienda",
    institute: "Recoger en colegio"
};
